// extracted by mini-css-extract-plugin
module.exports = {"button":"Incidents_button__3j9vK","createButton":"Incidents_createButton__aYSg7","link":"Incidents_link__3BwuM"};